// extracted by mini-css-extract-plugin
module.exports = {"base":"_2N1zk_","logo":"uJGePS"};